import { buildQueryString } from '../utils/queryString'
import axios from 'axios'
import { CALL_API } from '../middleware/api'
import { idParaRuta } from '../utils/idParaRuta'
import entorno from '../config/entorno'

export const CLIENT_LIST_REQUEST = 'CLIENT_LIST_REQUEST'
export const CLIENT_LIST_SUCCESS = 'CLIENT_LIST_SUCCESS'
export const CLIENT_LIST_FAILURE = 'CLIENT_LIST_FAILURE'

export const CLIENT_SEARCH_LIST_REQUEST = 'CLIENT_SEARCH_LIST_REQUEST'
export const CLIENT_SEARCH_LIST_SUCCESS = 'CLIENT_SEARCH_LIST_SUCCESS'
export const CLIENT_SEARCH_LIST_FAILURE = 'CLIENT_SEARCH_LIST_FAILURE'

export const UPDATE_CLIENT_FILTERS = 'UPDATE_CLIENT_FILTERS'
export const SELECT_CLIENT = 'SELECT_CLIENT'
export const SHOW_MESSAGE = 'SHOW_MESSAGE'
export const HIDE_MESSAGE = 'HIDE_MESSAGE'
export const RESET_CONFIGCLIENT = 'RESET_CONFIGCLIENT'

export const CLIENT_DETAIL_REQUEST = 'CLIENT_DETAIL_REQUEST'
export const CLIENT_DETAIL_SUCCESS = 'CLIENT_DETAIL_SUCCESS'
export const CLIENT_DETAIL_FAILURE = 'CLIENT_DETAIL_FAILURE'

export const MERCHANT_DETAIL_REQUEST = 'MERCHANT_DETAIL_REQUEST'
export const MERCHANT_DETAIL_SUCCESS = 'MERCHANT_DETAIL_SUCCESS'
export const MERCHANT_DETAIL_FAILURE = 'MERCHANT_DETAIL_FAILURE'

export const CLIENT_UPDATE_REQUEST = 'CLIENT_UPDATE_REQUEST'
export const CLIENT_UPDATE_SUCCESS = 'CLIENT_UPDATE_SUCCESS'
export const CLIENT_UPDATE_FAILURE = 'CLIENT_UPDATE_FAILURE'

export const CLIENT_DELETE_REQUEST = 'CLIENT_DELETE_REQUEST'
export const CLIENT_DELETE_SUCCESS = 'CLIENT_DELETE_SUCCESS'
export const CLIENT_DELETE_FAILURE = 'CLIENT_DELETE_FAILURE'

export const CLIENT_TOKEN_REQUEST = 'CLIENT_TOKEN_REQUEST'
export const CLIENT_TOKEN_SUCCESS = 'CLIENT_TOKEN_SUCCESS'
export const CLIENT_TOKEN_FAILURE = 'CLIENT_TOKEN_FAILURE'

export const CLIENT_SUMMARY_REQUEST = 'CLIENT_SUMMARY_REQUEST'
export const CLIENT_SUMMARY_SUCCESS = 'CLIENT_SUMMARY_SUCCESS'
export const CLIENT_SUMMARY_FAILURE = 'CLIENT_SUMMARY_FAILURE'

export const CLIENT_UPGRADE_REQUEST = 'CLIENT_UPGRADE_REQUEST'
export const CLIENT_UPGRADE_SUCCESS = 'CLIENT_UPGRADE_SUCCESS'
export const CLIENT_UPGRADE_FAILURE = 'CLIENT_UPGRADE_FAILURE'

export const CLIENT_VIRTUALPOINTS_REQUEST = 'CLIENT_VIRTUALPOINTS_REQUEST'
export const CLIENT_VIRTUALPOINTS_SUCCESS = 'CLIENT_VIRTUALPOINTS_SUCCESS'
export const CLIENT_VIRTUALPOINTS_FAILURE = 'CLIENT_VIRTUALPOINTS_FAILURE'

export const UPDATE_CLIENTVIRTUALPOINTS_FILTERS =
  'UPDATE_CLIENTVIRTUALPOINTS_FILTERS'

export const CLIENT_RELEASE_ACCOUNT_REQUEST = 'CLIENT_RELEASE_ACCOUNT_REQUEST'
export const CLIENT_RELEASE_ACCOUNT_SUCCESS = 'CLIENT_RELEASE_ACCOUNT_SUCCESS'
export const CLIENT_RELEASE_ACCOUNT_FAILURE = 'CLIENT_RELEASE_ACCOUNT_FAILURE'

export const CLIENT_CARD_ACTIVITY_REQUEST = 'CLIENT_CARD_ACTIVITY_REQUEST'
export const CLIENT_CARD_ACTIVITY_SUCCESS = 'CLIENT_CARD_ACTIVITY_SUCCESS'
export const CLIENT_CARD_ACTIVITY_FAILURE = 'CLIENT_CARD_ACTIVITY_FAILURE'

export const CLIENT_UPLOAD_CONTRACT_REQUEST = 'CLIENT_UPLOAD_CONTRACT_REQUEST'
export const CLIENT_UPLOAD_CONTRACT_SUCCESS = 'CLIENT_UPLOAD_CONTRACT_SUCCESS'
export const CLIENT_UPLOAD_CONTRACT_FAILURE = 'CLIENT_UPLOAD_CONTRACT_FAILURE'

export function clientList(params = {}) {
  let url = 'clients/'

  const qs = buildQueryString(params)
  if (qs) url += `?${qs}`

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: url,
      authenticated: true,
      extra: params,
      types: [CLIENT_LIST_REQUEST, CLIENT_LIST_SUCCESS, CLIENT_LIST_FAILURE]
    }
  }
}

export function clientSearchList() {
  const url = 'clients/orders/active/'

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: url,
      authenticated: true,
      types: [
        CLIENT_SEARCH_LIST_REQUEST,
        CLIENT_SEARCH_LIST_SUCCESS,
        CLIENT_SEARCH_LIST_FAILURE
      ]
    }
  }
}

export function updateClientFilters(data) {
  return dispatch => {
    const action = {
      type: UPDATE_CLIENT_FILTERS,
      data
    }
    dispatch(action)
  }
}

export function clientDetail(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `clients/${id}/`,
      authenticated: true,
      types: [
        CLIENT_DETAIL_REQUEST,
        CLIENT_DETAIL_SUCCESS,
        CLIENT_DETAIL_FAILURE
      ]
    }
  }
}

export function merchantDetail(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `merchant/client/${id}/`,
      authenticated: true,
      storeAPI: true,
      types: [
        MERCHANT_DETAIL_REQUEST,
        MERCHANT_DETAIL_SUCCESS,
        MERCHANT_DETAIL_FAILURE
      ]
    }
  }
}

export function editClient(id, data) {
  if (data.password === '') delete data.password

  return {
    [CALL_API]: {
      method: 'PATCH',
      endpoint: `clients/${id}/`,
      authenticated: true,
      data,
      types: [
        CLIENT_UPDATE_REQUEST,
        CLIENT_UPDATE_SUCCESS,
        CLIENT_UPDATE_FAILURE
      ]
    }
  }
}

export function clientDelete(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `clients/${id}/`,
      authenticated: true,
      types: [
        CLIENT_DELETE_REQUEST,
        CLIENT_DELETE_SUCCESS,
        CLIENT_DELETE_FAILURE
      ]
    }
  }
}

export function selectClient(obj) {
  return dispatch => {
    const action = {
      type: SELECT_CLIENT,
      data: obj
    }
    dispatch(action)
  }
}

export function showMessage() {
  return dispatch => {
    const action = {
      type: SHOW_MESSAGE
    }
    dispatch(action)
  }
}

export function hideMessage() {
  return dispatch => {
    const action = {
      type: HIDE_MESSAGE
    }
    dispatch(action)
  }
}

/** Login on behalf of a client */
export function clientToken(id) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `clients/${id}/token/`,
      authenticated: true,
      types: [CLIENT_TOKEN_REQUEST, CLIENT_TOKEN_SUCCESS, CLIENT_TOKEN_FAILURE]
    }
  }
}

export function resetConfigClient() {
  return dispatch => {
    const action = {
      type: RESET_CONFIGCLIENT
    }
    dispatch(action)
  }
}

export function getClientSummary(params = {}) {
  let url = 'orders/summary/'

  const qs = buildQueryString(params)
  if (qs) url += `?${qs}`

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: url,
      authenticated: true,
      types: [
        CLIENT_SUMMARY_REQUEST,
        CLIENT_SUMMARY_SUCCESS,
        CLIENT_SUMMARY_FAILURE
      ]
    }
  }
}

export function upgradeToOrganization(id) {
  return {
    [CALL_API]: {
      method: 'PATCH',
      endpoint: `clients/${id}/upgrade_to_organization/`,
      authenticated: true,
      types: [
        CLIENT_UPGRADE_REQUEST,
        CLIENT_UPGRADE_SUCCESS,
        CLIENT_UPGRADE_FAILURE
      ]
    }
  }
}

export function clientVirtualPoints(id, params = {}) {
  idParaRuta(id, 'clientVirtualPoints')

  // Los filtros (la página, sobre todo) no viajaban: el endpoint se construía
  // sólo con el id y `Pagination` no tenía ningún efecto sobre la petición.
  let url = `clients/${id}/virtual_points/`

  const qs = buildQueryString(params)
  if (qs) url += `?${qs}`

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: url,
      authenticated: true,
      extra: params,
      types: [
        CLIENT_VIRTUALPOINTS_REQUEST,
        CLIENT_VIRTUALPOINTS_SUCCESS,
        CLIENT_VIRTUALPOINTS_FAILURE
      ]
    }
  }
}

export function updateClientVirtualPoints(data) {
  return dispatch => {
    const action = {
      type: UPDATE_CLIENTVIRTUALPOINTS_FILTERS,
      data
    }
    dispatch(action)
  }
}

export function clientReleaseAccount(id) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `clients/${id}/not_fraud/`,
      authenticated: true,
      localAPI: false,
      types: [
        CLIENT_RELEASE_ACCOUNT_REQUEST,
        CLIENT_RELEASE_ACCOUNT_SUCCESS,
        CLIENT_RELEASE_ACCOUNT_FAILURE
      ]
    }
  }
}

export function listBankCardActivity(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `clients/${id}/bankcard_activities/`,
      authenticated: true,
      localAPI: false,
      types: [
        CLIENT_CARD_ACTIVITY_REQUEST,
        CLIENT_CARD_ACTIVITY_SUCCESS,
        CLIENT_CARD_ACTIVITY_FAILURE
      ]
    }
  }
}

export function uploadClientContract(clientId, file, onProgress) {
  return dispatch => {
    dispatch({ type: CLIENT_UPLOAD_CONTRACT_REQUEST })

    return new Promise((resolve, reject) => {
      console.log('📤 Uploading contract for client:', clientId)
      console.log('📄 File details:', {
        name: file.name,
        type: file.type,
        size: `${(file.size / 1024).toFixed(2)} KB`
      })

      // Validar tamaño del archivo (máximo 500KB)
      if (file.size > 500 * 1024) {
        const errorMessage = 'El archivo es demasiado grande (máximo 500KB)'
        console.error('❌ Upload failed:', errorMessage)
        dispatch({
          type: CLIENT_UPLOAD_CONTRACT_FAILURE,
          error: errorMessage
        })
        reject(new Error(errorMessage))
        return
      }

      // Validar tipo de archivo
      if (file.type !== 'application/pdf') {
        const errorMessage = 'Solo se aceptan archivos PDF'
        console.error('❌ Upload failed:', errorMessage)
        dispatch({
          type: CLIENT_UPLOAD_CONTRACT_FAILURE,
          error: errorMessage
        })
        reject(new Error(errorMessage))
        return
      }

      // Crear FormData
      const formData = new FormData()
      formData.append('file', file)

      // Obtener token y construir URL
      const accessToken = localStorage.getItem('accessToken')
      const BASE_URL = entorno.baseApi
      const url = `${BASE_URL}clients/${clientId}/contract/`

      // Configurar axios con progreso
      const config = {
        method: 'POST',
        url,
        data: formData,
        headers: {
          Authorization: `JWT ${accessToken}`,
          'Accept-Language': 'es',
          'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone
        },
        onUploadProgress: progressEvent => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          if (onProgress) {
            onProgress(percentCompleted)
          }
        }
      }

      // Usar axios directamente
      axios(config)
        .then(response => {
          console.log('✅ Contract uploaded successfully')
          console.log('📎 File URL:', response.data.file_url)

          dispatch({
            type: CLIENT_UPLOAD_CONTRACT_SUCCESS,
            data: {
              clientId,
              fileName: file.name,
              fileUrl: response.data.file_url,
              message: response.data.message
            }
          })

          resolve(response.data)
        })
        .catch(error => {
          const errorMessage =
            error.response?.data?.error ||
            error.response?.data?.message ||
            'Error al subir el contrato'
          console.error('❌ Upload error:', errorMessage)

          dispatch({
            type: CLIENT_UPLOAD_CONTRACT_FAILURE,
            error: errorMessage
          })

          reject(new Error(errorMessage))
        })
    })
  }
}

export function getClientContract() {
  // Esta función se mantiene por compatibilidad con código anterior
  // pero ya NO se usa porque el campo 'contract' viene directamente
  // en el objeto cliente desde la API

  // NOTA: El campo 'contract' viene en la lista de clientes desde el backend
  // Si contract !== null, el cliente tiene contrato
  // Si contract === null, el cliente NO tiene contrato

  // Esta función retorna null porque el chequeo ahora se hace directamente
  // en el componente usando obj.contract
  return null
}

export function downloadClientContract(clientId, contractUrl) {
  console.log('💾 Downloading contract for client:', clientId)
  console.log('📎 Contract URL:', contractUrl)

  if (!contractUrl) {
    console.error('❌ No contract URL provided')
    return false
  }

  try {
    // Abrir la URL en una nueva pestaña
    window.open(contractUrl, '_blank')
    console.log('✅ Contract opened in new tab')
    return true
  } catch (error) {
    console.error('❌ Error opening contract:', error)
    return false
  }
}
